<template>
  <div class="top_box">
    <div class="banner">
      <div class="title">{{ bannerMessage.title }}</div>
      <div class="line"></div>
      <div class="content">{{ bannerMessage.subtitle }}</div>
      <img :src="bannerMessage.navigationImgUrl" alt="" />
    </div>
    <div class="main_box">
      <div class="menu_box">
        <div class="left_menu">
          <div class="left_title">
            <div class="title1">信息公开</div>
            <div class="title2">INFORMATION</div>
          </div>
          <div class="left_item">
            <div
              class="item"
              v-for="(item, index) in menuList"
              :key="'item' + index"
              :class="{ choose: item.key === chooseKey }"
              @click="changeItem(item.key)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="right_article">
          <!-- <groupOverviewIntro v-if="chooseKey === 1"></groupOverviewIntro> -->
          <peopleGet v-if="chooseKey === 1" cid="15"></peopleGet>
          <peopleGet v-if="chooseKey === 2" cid="16"></peopleGet>
          <socialDuty v-if="chooseKey === 3"></socialDuty>
          <contactUs v-if="chooseKey === 4"></contactUs>
        </div>
      </div>
    </div>
    <img class="bottom_png" src="@/assets/text/bg_main.png" alt="" />
  </div>
</template>
<script setup>
import api from "@/api/api";
import { ref, watch, onMounted } from "vue";
import peopleGet from "./components/peopleGet.vue";
import socialDuty from "./components/socialDuty.vue";
import contactUs from "./components/contactUs.vue";
import { useRoute, useRouter } from "vue-router";
const route = useRoute();
const router = useRouter();
let chooseKey = ref(1);
let bannerMessage = ref({});
let menuList = ref([
  {
    name: "人才招聘",
    key: 1,
  },
  {
    name: "公示公告",
    key: 2,
  },
  {
    name: "联系我们",
    key: 4,
  },
]);
const changeItem = (key) => {
  // chooseKey.value = key;
  router.push({
    query: {
      id: key,
    },
  });
};
const getBanner = async () => {
  let res = await api.getPageConfigDetail(116);
  if (res.code === "0") {
    bannerMessage.value = res.res.data;
  }
};
getBanner();
watch(
  () => route,
  (newval) => {
    if (newval && newval.query.id) {
      chooseKey.value = newval.query.id * 1;
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  },
  { deep: true, immediate: true }
);
</script>
<style lang="less" scoped>
.top_box {
  width: 100%;
  .banner {
    width: 100%;
    height: 427px;
    position: relative;
    .title {
      position: absolute;
      left: 170px;
      top: 120px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 44px;
      color: #ffffff;
    }
    .line {
      position: absolute;
      left: 170px;
      top: 223px;
      width: 60px;
      height: 2px;
      background: rgba(255, 255, 255, 0.4);
    }
    .content {
      position: absolute;
      left: 170px;
      top: 254px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #ffffff;
    }
    img {
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: -1;
    }
  }
  .main_box {
    width: 100%;
    // 底部留白用固定值：原来 12.59vh 会让窗口越高留白越多（2000 高的窗口就是 250px）
    padding: 42px 8.33vw;
    box-sizing: border-box;
    .menu_box {
      display: flex;
      .left_menu {
        height: 78px;
        width: 180px;
        background: #f0f0f0;
        margin-right: 63px;
        z-index: 3;
        .left_title {
          width: 100%;
          height: 74px;
          background: #006ab1;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          justify-content: center;
          .title1 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 16px;
            color: #ffffff;
            margin-right: 17px;
          }
          .title2 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #ffffff;
            margin-right: 17px;
            margin-top: 4px;
          }
        }
        .left_item {
          .item {
            cursor: pointer;
            text-align: right;
            height: 37px;
            line-height: 37px;
            padding-right: 17px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            background: #f0f0f0;
          }
          .choose {
            background: #223e62 !important;
            color: #ffffff !important;
          }
        }
      }
      .right_article {
        z-index: 2;
        position: relative;
        width: calc(100% - 243px);
      }
    }
  }
  .bottom_png {
    width: 100%;
    position: absolute;
    bottom: 0px;
    z-index: -2;
  }
}
</style>